module.exports = __webpack_public_path__ + "static/media/feed-authentication-icon.86d90f14.svg";